define('home/views/ChannelCardCollectionView',[
    'backbone',
    'core/bus',

    'home/views/GenericCardCollectionView',
    'home/views/ChannelCardFavoriteView',
    'home/views/ChannelCardCreateView',
    'home/views/ChannelCardTrendingView',
    'home/views/ChannelCardShareView',
    'home/views/ChannelFeedEmptyView',
    'home/mixins/withViewFeedTracking',
], function (
    Backbone,
    bus,

    GenericCardCollectionView,
    ChannelCardFavoriteView,
    ChannelCardCreateView,
    ChannelCardTrendingView,
    ChannelCardShareView,
    ChannelFeedEmptyView,
    withViewFeedTracking
) {
    'use strict';

    var ChannelCardCollectionView = GenericCardCollectionView.extend({
        itemView: function (options) {
            switch (options.model.get('verb')) {
            case 'favorite':
                return new ChannelCardFavoriteView(options);
            case 'create':
                return new ChannelCardCreateView(options);
            case 'trending':
                return new ChannelCardTrendingView(options);
            case 'share':
                return new ChannelCardShareView(options);
            default:
                // So that an error isn't thrown by returning null when a view is
                // expected, for activity types not supported by channel feeds
                return new Backbone.View();
            }
        },

        itemViewOptions: function (item, index) {
            var options = GenericCardCollectionView.prototype.itemViewOptions.call(this, item, index);
            options.enableBestOfDisqusCallout = this.enableBestOfDisqusCallout;
            options.filterVerbs = this.filterVerbs;
            options.isChannelFeed = this.isChannelFeed;

            return options;
        },

        emptyView: ChannelFeedEmptyView,

        emptyViewOptions: function () {
            return {
                model: this.channel,
            };
        },

        initialize: function (options) {
            GenericCardCollectionView.prototype.initialize.call(this, options);
            options = options || {};
            this.enableBestOfDisqusCallout = options.enableBestOfDisqusCallout;
            this.filterVerbs = options.filterVerbs;
            this.isChannelFeed = options.isChannelFeed;

            this.listenToOnce(this, 'showFirstItem', function () {
                bus.trigger('showFirstCard', 'channel');
            });
        },
    });

    withViewFeedTracking.call(ChannelCardCollectionView.prototype);

    return ChannelCardCollectionView;
});

